import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'

const application = Application.start()
const controllers = import.meta.glob('./**/*_controller.js', { eager: true })

// Controllers from components
const componentsControllers = import.meta.glob('./../../../components/**/controller.js', { eager: true })

registerControllers(application, controllers)

for (let path in componentsControllers) {
  let module = componentsControllers[path];
  let name = path
    .match(/.*\/components\/(.+)\/controller\.js$/)[1]

  application.register(name, module.default);
}
